"use client";

import { $api } from "@/lib/api-client";

interface UseFetchNftInfoParams {
  collectionAddress: string;
  tokenId: number;
}

export const useFetchNftInfo = ({
  collectionAddress,
  tokenId,
}: UseFetchNftInfoParams) => {
  return $api.useQuery(
    "get",
    "/nft/{collectionAddress}/{tokenId}",
    {
      params: {
        path: {
          collectionAddress,
          tokenId,
        },
      },
    },
    {
      enabled: !!collectionAddress && tokenId !== undefined,
    },
  );
};

interface NftInfoItem {
  collectionAddress: string;
  tokenId: number;
}

export const useFetchMultipleNftInfo = (items: NftInfoItem[]) => {
  return $api.useQuery(
    "post",
    "/nft/bulk",
    {
      body: { items },
    },
    {
      enabled: items.length > 0,
    },
  );
};
